import { render, staticRenderFns } from "./CzSegments.vue?vue&type=template&id=606ed76c&scoped=true&"
import script from "./CzSegments.vue?vue&type=script&lang=ts&"
export * from "./CzSegments.vue?vue&type=script&lang=ts&"
import style0 from "./CzSegments.vue?vue&type=style&index=0&id=606ed76c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606ed76c",
  null
  
)

export default component.exports